import { render, staticRenderFns } from "./LedgerAccountWisePrintReport.vue?vue&type=template&id=467be1ff&scoped=true&"
import script from "./LedgerAccountWisePrintReport.vue?vue&type=script&lang=js&"
export * from "./LedgerAccountWisePrintReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467be1ff",
  null
  
)

export default component.exports